import { type ApiResponseSingle, type ApiRequest, properCallApi, type ApiResponse } from '../tenantClient';
import { type Order } from './order';
import { type AuthObject } from './registration';

export const requestPasscodeQueryKey = 'registration.requestPasscodeQueryKey';
export const listOrdersQueryKey = 'registration.listOrdersQueryKey';
export const registrationInfoQueryKey = 'registration.infoQueryKey';

export interface VerifyUserRequest {
  email: string
  eventId: string
}

export interface RequestPasscodeRequest {
  email: string
  eventId: string
}

export interface VerifyPasscodeRequest {
  email: string
  passcode: string
  eventId: string
}

export interface VerifyUserResponse {
  existingUser: boolean
  token?: AuthObject
}

export interface LoginRequest {
  uid: string
  client: string
  token: string
}

interface RegistrationInfo {
  existRegistration: boolean
  existGroupRegistration: boolean
}

export function verifyUser(createTenantRequest: () => ApiRequest) {
  const request = createTenantRequest();
  return async (
    params: VerifyUserRequest
  ): Promise<ApiResponseSingle<VerifyUserResponse>> => {
    request.method = 'POST';
    request.endpoint.path = '/api/v1/users/verify_user';
    request.payload = params;
    return await properCallApi<ApiResponseSingle<VerifyUserResponse>>(request);
  };
};

export function requestPasscode(createTenantRequest: () => ApiRequest) {
  const request = createTenantRequest();
  return async (
    params: RequestPasscodeRequest
  ): Promise<ApiResponseSingle<void>> => {
    request.method = 'POST';
    request.endpoint.path = '/api/v1/users/request_passcode';
    request.payload = params;
    return await properCallApi<ApiResponseSingle<void>>(request);
  };
};

export function verifyPasscode(createTenantRequest: () => ApiRequest) {
  const request = createTenantRequest();
  return async (
    params: VerifyPasscodeRequest
  ): Promise<ApiResponseSingle<AuthObject>> => {
    request.method = 'POST';
    request.endpoint.path = '/api/v1/users/verify_passcode';
    request.payload = params;
    return await properCallApi<ApiResponseSingle<AuthObject>>(request);
  };
}

export function login(createTenantRequest: () => ApiRequest) {
  const request = createTenantRequest();
  return async (
    params: LoginRequest
  ): Promise<ApiResponseSingle<AuthObject>> => {
    request.method = 'POST';
    request.endpoint.path = '/api/v1/users/login';
    request.payload = params;
    return await properCallApi<ApiResponseSingle<AuthObject>>(request);
  };
}

export function listOrders(createTenantRequest: () => ApiRequest) {
  const request = createTenantRequest();
  return async (
    params: { eventId: string | number }
  ): Promise<ApiResponse<Order>> => {
    request.method = 'GET';
    request.endpoint.path = '/api/v1/users/orders';
    request.endpoint.query = {
      eventId: params.eventId
    };
    return await properCallApi<ApiResponse<Order>>(request);
  };
}

export function loadRegistrationInfo(createTenantRequest: () => ApiRequest) {
  const request = createTenantRequest();
  return async (
    eventId: string
  ): Promise<ApiResponseSingle<RegistrationInfo>> => {
    request.method = 'GET';
    request.endpoint.path = '/api/v1/users/registration_info';
    request.endpoint.query = { eventId };
    return await properCallApi<ApiResponseSingle<RegistrationInfo>>(request);
  };
}
